import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { skuBrandKeys } from "./query-keys";

const YEAR_MS = 365 * 86_400_000;

/** Newest `sku.brand_import` audit event (who / when / counts), or null. Admin-only endpoint. */
export function useLastBrandImport() {
  return useQuery({
    queryKey: skuBrandKeys.lastImport,
    queryFn: async () => {
      const now = Date.now();
      const { data, error } = await apiClient.GET("/v1/audit-events", {
        params: {
          query: {
            activity: "sku.brand_import",
            date_from: new Date(now - YEAR_MS).toISOString(),
            date_to: new Date(now + 60_000).toISOString(),
            limit: 1,
          },
        },
      });
      if (error) throw error;
      return data.items[0] ?? null;
    },
  });
}
